import { Text } from "@certn/cascadia";
import { Icon } from "@certn/cascadia-react";
import { css } from "@emotion/css";

interface PackageHeaderProps {
  title: string;
  isDisabled: boolean;
  testID: string;
}

export function PackageHeader({
  title,
  isDisabled,
  testID,
}: PackageHeaderProps) {
  return (
    <div className={styles.titleSection}>
      <div className={styles.title}>
        <Icon name="package_2" color="icon-accent-tofino" />
        <Text style="global/heading-medium" testID={`${testID}-package-name`}>
          {title}
        </Text>
      </div>
      {isDisabled && <Icon name="lock" color="icon-weak" testID="lock-icon" />}
    </div>
  );
}

const styles = {
  titleSection: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  title: css({
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
  }),
};
